/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=TdtMap&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=TdtMap&lang=js"

import "./index.vue?vue&type=style&index=0&id=115679f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115679f0"]])

export default __exports__